import OldInspectionStatus from './OldInspectionStatus';

export default OldInspectionStatus;
